import { defineMessages } from 'react-intl';

export const getHelpModalMessages = defineMessages({
  title: {
    defaultMessage: 'Get Help',
    id: 'YsCPhT',
    description: 'Title of the Get Help support request modal',
  },
  reasonSelectLabel: {
    defaultMessage: 'Type of issue',
    id: 'SnSP7y',
    description: 'Label for the reason dropdown in the Get Help modal',
  },
  reasonSelectPlaceholder: {
    defaultMessage: 'Select an issue',
    id: 'c2Bk91',
    description: 'Placeholder text for the reason dropdown in the Get Help modal',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    id: 'Qpu53V',
    description: 'Label for the Cancel button in the Get Help modal',
  },
  continueButton: {
    defaultMessage: 'Continue',
    id: 'esZg8K',
    description: 'Label for the Continue button in the Get Help modal',
  },
});
